import { render, staticRenderFns } from "./graficosProdutos.vue?vue&type=template&id=b9922cb8"
import script from "./graficosProdutos.vue?vue&type=script&lang=js"
export * from "./graficosProdutos.vue?vue&type=script&lang=js"
import style0 from "./graficosProdutos.vue?vue&type=style&index=0&id=b9922cb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports